import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  DestroyRef,
  HostListener,
  inject,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LUCIDE_ICONS, LucideAngularModule, LucideIconProvider, icons } from 'lucide-angular';
import { SimplebarAngularModule } from 'simplebar-angular';
import { MenuItem } from './menu.model';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../core/services/language.service';
import { CutomDropdownComponent } from '../../Component/customdropdown';
import { Store } from '@ngrx/store';
import { getLayout, getSidebarsize } from '../../store/layout/layout-selector';
import { CommonModule } from '@angular/common';

import { AuthenticationService } from '../../core/services/auth.service';
import { CancelacionesFraudesService } from '../../pages/administracion/cancelaciones-fraude/cancelaciones-fraudes.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    SimplebarAngularModule,
    CutomDropdownComponent,
    TranslateModule,
    RouterModule,
    LucideAngularModule,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider(icons) }, LanguageService],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  menuItems: MenuItem[] = [];
  isMoreMenu: boolean = false;
  navData: MenuItem[] = [];
  navbarMenuItems: any = [];
  layout: any;
  size: any;

  menu: MenuItem[] = [];

  private store = inject(Store);
  private destroyRef = inject(DestroyRef);
  private cancelacionesFraudesService = inject(CancelacionesFraudesService);

  constructor(
    public translate: TranslateService,
    private authService: AuthenticationService,
  ) {
    translate.setDefaultLang('sp');
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    if (document.documentElement.getAttribute('data-layout') == 'horizontal') {
      if (document.documentElement.clientWidth >= 1025) {
        setTimeout(() => {
          this.updateMenu();
        }, 500);
      }
    }
  }

  ngOnInit(): void {
    this.authService
      .getMenuList()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          if (res.success && res.data.length > 0) {
            // Initialize the navData and menuItems
            this.menu = res.data[0].menu;
            this.navData = this.menu;
            this.menuItems = this.navData;
            const cantidadModulos = Number(res.data[0].cantidadModulos) | 0;
            this.authService.actualizarCantidadModulos(cantidadModulos);

            this.cancelacionesFraudesService.verificarMenuParaCancelacionFraudes(this.menu);
          }
        },
      });

    // Get Layout
    this.store
      .select(getLayout)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.layout = data;
        if (this.layout == 'horizontal') {
          setTimeout(() => {
            this.updateMenu();
          }, 1500);
        } else {
          this.menuItems = this.menu;
        }
      });

    // Get size
    this.store
      .select(getSidebarsize)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.size = data;
      });
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    if (this.layout == 'horizontal') {
      setTimeout(() => {
        this.updateMenu();
      }, 1500);
    } else {
      this.menuItems = this.menu;
    }
  }

  // Display Menu
  updateMenu() {
    const isMoreMenu = false;
    const navbarHeader = document.querySelector('.navbar-header');
    const navbarNav = document.getElementById('navbar-nav') as any;

    // count width of horizontal menu
    const fullWidthOfMenu = navbarHeader!.clientWidth - 150;

    const menuWidth = fullWidthOfMenu || 0;
    let totalItemsWidth = 0;
    const visibleItems: any = [];
    const hiddenItems: any = [];

    const moreMenuItem = {
      id: 'more',
      label: 'more',
      icon: 'network',
      subItems: null,
      link: 'sidebarMore',
      stateVariables: isMoreMenu,
      click: (e: any) => {
        e.preventDefault();
        this.isMoreMenu = !this.isMoreMenu;
      },
    };

    for (let i = 0; i < this.navData.length; i++) {
      const itemWidth = navbarNav?.children[i]?.offsetWidth;
      totalItemsWidth += itemWidth;

      if (totalItemsWidth <= menuWidth - 50 || window.innerWidth < 768) {
        visibleItems.push(this.navData[i]);
      } else {
        if (!this.navData[i].isTitle) {
          hiddenItems.push(this.navData[i]);
        }
      }
      if (i + 1 === this.navData.length) {
        moreMenuItem.subItems = hiddenItems;
      }
    }

    const updatedMenuItems = hiddenItems.length > 0 ? [...visibleItems, moreMenuItem] : visibleItems;
    this.menuItems = updatedMenuItems;
  }

  hasItems(item: MenuItem) {
    return item.menu !== undefined ? item.menu.length > 0 : false;
  }

  // Hide Sidebar
  hideSidebar() {
    const sidebarOverlay = document.getElementById('sidebar-overlay') as any;
    sidebarOverlay.classList.add('hidden');
    document.documentElement.querySelector('.app-menu')?.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  }
}
